import React from "react";
import Wrapper from "../../hoc/Wrapper/Wrapper";
import BreadcrumbsTemp from "../../components/UI/BreadCrumb/BreadCrumbCustom";
import { Grid } from "@material-ui/core";
import CarContracrAddForm from "../../components/CarContract/Add/CarContractAddForm";

const CarContractAddPage = (props) => {
  return (
    <Wrapper>
      <BreadcrumbsTemp
        items={[
          {
            title: "افزودن معاملات ماشین ",
            to: "/car-contract/add",
          },
        ]}
      />

      <Grid container={true}>
        <Grid item xs={12}>
          <CarContracrAddForm />
        </Grid>
      </Grid>
    </Wrapper>
  );
};

export default CarContractAddPage;
